/**
 * Platform Detection Utility
 */

export type Platform = "android" | "ios" | "unknown";

/**
 * Detect the user's mobile platform based on user agent
 */
export function detectPlatform(): Platform {
  const userAgent = navigator.userAgent || "";

  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !("MSStream" in window)) {
    return "ios";
  }

  // Android detection
  if (/android/i.test(userAgent)) {
    return "android";
  }

  return "unknown";
}
